module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/website-badge-084367b27edb3307dda6c18479d94e14.svg";